module.exports = __webpack_public_path__ + "media/images/logo_suteki-nice-43b31f272d810d848691dfe3ea96f286.png";